export class SearchCondition {
  campus_code: string = null
  name: string = ""
  page: number = 1
  row_count: number =  100
}

export class Campus {
  id: number
  campus_code: number
  name: string
  full_count: number
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.campus_code = x.campus_code;
    this.name = x.name;
    this.full_count = x.full_count;
  }
}